import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "field is-horizontal" }
const _hoisted_2 = { class: "field-body" }
const _hoisted_3 = {
  key: 0,
  class: "field"
}
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "field" }

import { useRoute } from 'vue-router';
import FlowReportFilters from '@/features/reports/components/flows/FlowReportFilters.vue';
import DateRangeFilter from '@/features/reports/components/DateRangeFilter.vue';
import ReportDownloader from '@/features/reports/components/ReportDownloader.vue';
import UsageDateRangeFilter from '@/features/reports/components/usage/UsageDateRangeFilter.vue';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportFilters',
  setup(__props) {

const activeRoute = useRoute();

const isFlowReportDisplayed = computed(() => activeRoute.name === 'reports-flows');
const isIntentsReportDisplayed = computed(() => activeRoute.name === 'reports-intents');
const isUsageReportDisplayed = computed(() => activeRoute.name === 'reports-usage');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isFlowReportDisplayed.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(FlowReportFilters)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (!isUsageReportDisplayed.value)
          ? (_openBlock(), _createBlock(DateRangeFilter, { key: 0 }))
          : _createCommentVNode("", true),
        (isUsageReportDisplayed.value)
          ? (_openBlock(), _createBlock(UsageDateRangeFilter, { key: 1 }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(ReportDownloader)
      ])
    ])
  ]))
}
}

})